/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-27 13:33:12
 * @LastEditors: hongye
 * @LastEditTime: 2025-04-03 17:37:19
 */
/*
 * 员工相关接口
 */
import request from '../request'
import { bindEmailType, ILoginParams, IUpdatePwdParams, LoginCheck, sendEmailType } from '../model'

enum Api {
  LOGIN_API = '/staff/newWebLogin',
  CHECK_LOGIN_API = '/staff/checkWebNewDevice',
  LOGOUT_API = '/staff/webLoginOut',
  FORGET_PWD = '/staff/forgetPwd',
  CHANGE_INIT_PWD = '/staff/changeInitPwd',
  CHANGE_PWD = '/staff/changePwd'
}

export default class ajaxAuthService {
  /**
   * 登录
   * @param data
   * @returns
   */
  static login(data: ILoginParams): Promise<any> {
    return request.post(Api.LOGIN_API, data)
  }
   /**
   * 登录
   * @param data
   * @returns
   */
   static checkNewDevice(data: LoginCheck | undefined): Promise<any> {
    return request.post(Api.CHECK_LOGIN_API, data)
  }
  /**
   * 退出登录
   * @returns
   */
  static logOut(): Promise<any> {
    return request.get(Api.LOGOUT_API)
  }
  /**
   * 忘记密码
   * @param data
   * @returns
   */
  static forgetPwd(data: ILoginParams): Promise<any> {
    return request.post(Api.FORGET_PWD, data)
  }
  /**
   * 修改初始密码
   * @param data
   * @returns
   */
  static changeInitPwd(data: ILoginParams): Promise<any> {
    return request.post(Api.CHANGE_INIT_PWD, data)
  }
  /**
   * 修改密码
   * @param data
   * @returns
   */
  static changePwd(data: IUpdatePwdParams): Promise<any> {
    return request.post(Api.CHANGE_PWD, data)
  }
  /**
   * 90天密码失效--修改密码
   * @param data
   * @returns
   */
  static updatePwd(data: IUpdatePwdParams): Promise<any> {
    return request.post('/staff/updateWebPwd', data)
  }
  /** 查询是否绑定邮箱 */
  static checkEmail(): Promise<any> {
    return request.post('/staff/checkEmail', { id: '1' })
  }
  
  /**
   * @description: 绑定邮箱
   * @param {*} data
   * @return {*}
   */
  static bindEmail(data: bindEmailType): Promise<any> {
    return request.post('/staff/bindEmail', data)
  }
  /**
   * @description: 绑定邮箱-下次再说
   * @return {*}
   */
  static nextBindEmail(): Promise<any> {
    return request.post('/staff/nextBindEmail', { id: 0 })
  }
  /**
   * @description: 发送邮箱验证码
   * @param {*} data
   * @return {*}
   */
  static sendEmail(data: sendEmailType): Promise<any> {
    return request.post('/captcha/sendEmail', data)
  }
}
